export default __webpack_public_path__ + "static/media/env2.80e1b5f9.hdr";